








































































































































































import {Component, Ref, Vue} from "vue-property-decorator";
import {Action, Getter} from "vuex-class";
import {FormRowWings, SelectWings, FieldTooltip} from "@/components";
import {cloneDeep, isEqual} from "lodash";
import {notifyConfirm, notifyDelete, notifyError} from "@/utils/notify-helper";
import {AddressBookContactItem} from "@/store/addressbooks/types";

Component.registerHooks([
  'beforeRouteLeave',
]);

@Component({components: {FormRowWings, SelectWings, FieldTooltip}})
export default class AddressBookContact extends Vue {
  @Getter("addressBookContacts") addressBookContactsResponse: any;
  @Action("saveAddressBookContact") actionSave: any;
  @Action("deleteAddressBookContact") actionDelete: any;
  @Ref('validator') validator:any;

  private item:AddressBookContactItem=Object.create({})
  private itemSaved:AddressBookContactItem=Object.create({})

  created() {
    if (this.$route.params.contactId) {
      const data = this.addressBookContactsResponse
          .find((blc:AddressBookContactItem) => blc.id?.toString() === this.$route.params.contactId)
      if (data) {
        this.item = Object.assign({},this.item, data);
        this.itemSaved = cloneDeep(Object.assign({},this.item, data));
      }
    }
  }

  back() {
    this.$router.push(`/address_book/group/${this.$route.params.id}/contact`);
  }

  onSaveItem():Promise<void> {
    return new Promise( async (resolve, reject) => {
      if (!await this.validator.validate()) {
        notifyError(null, this.validator.errors)
        return
      }
      try {
        await this.actionSave({
          id: this.$route.params.contactId,
          groupId: this.$route.params.id,
          ...this.item
        });
        this.itemSaved = cloneDeep(this.item);
        resolve();
        this.back();
      } catch (error) {
        reject()
        notifyError(error);
      }
    })
  }

  async onDeleteItem():Promise<void> {
    if (!await notifyDelete()) return
    try {
      await this.actionDelete({
        contactIds: [this.$route.params.contactId],
      })
      this.itemSaved = this.item;
      this.back();
    } catch (error) {
      notifyError(error);
    }
  }

  beforeRouteLeave(to:any, from:any, next:any) {
    let isChange = !isEqual(this.item,this.itemSaved);
    notifyConfirm(isChange, this.onSaveItem, next);
  }
}
